import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IacctRange, Iacct } from '../../../shared/models/models';
import { Subscription } from 'rxjs';

@Component({
  selector: 'iacct-list',
  templateUrl: './iact-list.component.html',
})
export class IacctListComponent implements OnInit {
  iaccts: Iacct[];
  iacctsSub: Subscription;
  iacctRanges: IacctRange[] = null;

  routeDataSub: Subscription;
  rangeName: string;
  accountRangeStart: number;
  accountRangeEnd: number;

  prevIacctRange: IacctRange;
  iacctRange: IacctRange;
  nextIacctRange: IacctRange;
  byNumber: boolean = false;
  rangeId: number = null;

  constructor(private readonly route: ActivatedRoute) {}

  ngOnInit(): void {
      this.routeDataSub = this.route.paramMap.subscribe((params) => {
          this.iaccts = null;
          this.iacctRanges = null;
          this.iacctRange = null;
          this.prevIacctRange = null;
          this.nextIacctRange = null;

          const range = params.get('rangeId');
          if (range === 'byNumber') {
              this.byNumber = true;
          } else {
              this.rangeId = Number(range);
          }
          this.updateIaccts(this.rangeId);
      });
  }

  updateIaccts(rangeId: number) {
      this.route.data.subscribe(({ iacctRanges, iaccts }: { iacctRanges: IacctRange[], iaccts: Iacct[] }) => {
          this.iacctRanges = iacctRanges;
          this.iaccts = iaccts;
          if (rangeId !== null) {
              const rangeIds = this.iacctRanges.map((x) => x['rangeId']);
              const index = rangeIds.indexOf(rangeId);

              this.iacctRange = rangeId != null && index >= 0 ? this.iacctRanges[index] : null;
              this.prevIacctRange = rangeId != null && index > 0 ? this.iacctRanges[index - 1] : null;
              this.nextIacctRange = rangeId != null && index < rangeIds.length - 1 ? this.iacctRanges[index + 1] : null;
          }
      });
  }

  getDescriptionCount() {
      let descCount = 0;
      this.iaccts.forEach((e) => {
          if (e.longDescription) {
              descCount++;
          }
      });
      return descCount;
  }

  // https://github.com/angular/angular/issues/18967
  // As of Angular 8, cannot yet pass Input to Components via Router
  //@Input() accountRangeStart: number = 0;
  //@Input() accountRangeEnd: number = 0;
}
